import { ResourcesServiceBase, WsResources } from "./wsdl/WsResources/v1.01/WsResources";

export {
    WsResources
};

export class ResourcesService extends ResourcesServiceBase {
}
